<template>
  <modal
    name="edit-shift-plan"
    class="modal--translation"
    v-cloak height="auto"
    :scrollable="true"
    :adaptive="true"
    :pivot-y="0.25"
    @before-open="beforeOpen"
  >
    <h5 class="modal-title">{{ title }} - <span class="selected-date">{{
        date ? date.format('DD. MM. YYYY') : null
      }}</span></h5>

    <button @click="closeModal()" type="button" class="close close-modal">
      <i class="fal fa-fw fa-times"></i>
    </button>

    <shift-plan-embed-form
      ref="shiftPlanEmbedForm"
      :work-interval-types="selectedEmployeeContract.plan_interval_types"
      :default-interval="defaultInterval"
      :default-form-data="defaultFormData"
      :trans="trans"
      @intervals-overlap="intervalIsOverlaid = $event"
    />

    <b-alert
      v-if="intervalIsOverlaid"
      show variant="danger"
      class="col-12 d-flex align-items-center mt-3"
    >
      <i class="fal fa-exclamation-circle fa-2x mr-2"></i>
      <strong>
        {{ trans.form.overlay_intervals }}
      </strong>
    </b-alert>

    <div class="text-center" style="margin-top: 30px;">
      <button
        @click="submitForm()"
        class="btn btn-block btn-primary"
        type="submit"
        :disabled="intervalIsOverlaid"
      >
        {{ trans.saveBtn }}
      </button>

      <!-- delete iba na dotykových zariadeniach (bez hoveru sa inline trash v kalendári nedá zobraziť) -->
      <button
        v-if="shiftPlanId && trans.deleteWarning"
        @click="deleteShiftPlan()"
        type="button"
        class="btn btn-block btn-danger btn-delete-touch mt-2"
      >
        <i class="far fa-trash-alt"></i> {{ trans.deleteBtn }}
      </button>
    </div>
  </modal>
</template>

<script>

import {cloneDeep} from "lodash";

const userLanguage = document.documentElement.lang;

export default {
  name: 'shift-plan-modal-form',
  data: function () {
    return {
      day: {},
      date: null,
      title: '',
      shiftPlanId: null,
      intervalIsOverlaid: false,
      defaultInterval: {
        plan_interval_type: 'work',
        from: moment().hours(8).minutes(0).seconds(0).format('HH:mm'),
        to: moment().hours(12).minutes(0).seconds(0).format('HH:mm')
      },
      interval: {
        from: null,
        to: null
      },
      defaultFormData: {},
      timePickerConfig: {
        enableTime: true,
        noCalendar: true,
        time_24hr: true,
        enableSeconds: false,
        dateFormat: 'H:i',
        defaultHour: 8,
        defaultMinute: 0,
        locale: userLanguage
      },
    }
  },

  props: {
    'trans': {
      type: Object
    },
    'selectedEmployeeContract': {
      type: Object,
      default: {
        first_name: '',
        last_name: ''
      }
    },
  },

  created() {

  },

  methods: {
    beforeOpen(event) {
      const day = event.params.day;

      let form = {
        employee_contract_id: this.selectedEmployeeContract.employee_contract_id,
        id: day.shiftPlan ? day.shiftPlan.id : null,
        intervals: []
      };

      this.date = moment(day.date);
      form.date = this.date.format('YYYY-MM-DD');
      this.url = this.baseUrl + "/" + this.date.format('YYYY') + "/" + this.date.format('MM') + "/" + this.date.format('DD');
      this.shiftPlanId = day.shiftPlan ? day.shiftPlan.id : null;

      if (day.shiftPlan && day.shiftPlan.intervals && day.shiftPlan.intervals.length > 0) {
        this.title = this.trans.form.title_edit;

        form.intervals = day.shiftPlan.intervals.map((interval) => {
          return {
            ...this.defaultInterval,
            from: moment(interval.from).format('HH:mm'),
            to: moment(interval.to).format('HH:mm'),
            plan_interval_type: interval.planIntervalType,
          };
        });
      } else {
        this.title = this.trans.form.title_add;
        form.intervals = cloneDeep([this.defaultInterval]);
      }

      this.defaultFormData = form;
    },

    submitForm() {
      const _this = this;

      // intervaly zoradíme až pri ukladaní, aby sa riadky neprehadzovali počas vypĺňania
      this.$refs.shiftPlanEmbedForm.sortIntervals();

      const data = this.$refs.shiftPlanEmbedForm.getData();

      // validate intervals
      if (this.$refs.shiftPlanEmbedForm.validateIntervals()) {
        this.intervalIsOverlaid = true;
        return;
      } else this.intervalIsOverlaid = false;

      // send request
      axios.post('/shift-plans/plans/save', data)
        .then(response => {
          this.onSuccess(response)
        })
        .catch(errors => {
          this.onFail(errors)
        })
    },

    onSuccess(response) {
      this.closeModal();
      this.$emit('refresh-calendar');
      this.$emit('refreshattendance');

      this.$notify({
        type: 'success',
        title: 'Success!',
        text: response.data.message ? response.data.message : 'Item successfully created.'
      });
    },

    onFail(error) {
      this.closeModal();
      let errorMsg = '';

      if (error.response.data.errors && Object.keys(error.response.data.errors).length > 0) {
        errorMsg = Object.keys(error.response.data.errors).map(function (key) {
          return error.response.data.errors[key][0];
        }).join('<br />');
      } else {
        errorMsg = error.response.data.message ? error.response.data.message : 'An error has occured.';
      }

      this.$notify({type: 'error', title: 'Error!', text: errorMsg});
    },

    deleteShiftPlan() {
      const _this = this;

      this.$modal.show('dialog', {
        title: _this.trans.deleteWarning.title,
        text: _this.trans.deleteWarning.text,
        buttons: [
          {title: _this.trans.deleteWarning.no},
          {
            title: '<span class="btn-dialog btn-danger">' + _this.trans.deleteWarning.ok + '</span>',
            handler: function () {
              _this.$modal.hide('dialog');

              axios.delete('/shift-plans/plans/' + _this.shiftPlanId)
                .then((response) => {
                  _this.closeModal();
                  _this.$emit('refresh-calendar');
                  _this.$emit('refreshattendance');
                  _this.$notify({
                    type: 'success',
                    title: 'Success!',
                    text: response.data.message ? response.data.message : 'Item successfully deleted.'
                  });
                })
                .catch((error) => {
                  _this.$emit('refresh-calendar');
                  _this.$emit('refreshattendance');
                  _this.$notify({
                    type: 'error',
                    title: 'Error!',
                    text: error.response.data.message ? error.response.data.message : 'An error has occured.'
                  });
                });
            }
          }
        ]
      });
    },

    closeModal() {
      this.$modal.hide('edit-shift-plan');
    }
  },
};
</script>

<style scoped>
/* delete tlačidlo len na dotykových zariadeniach (bez hoveru) */
.btn-delete-touch {
  display: none;
}

@media (hover: none) {
  .btn-delete-touch {
    display: block;
  }
}
</style>



// WEBPACK FOOTER //
// resources/assets/admin/js/shift-plan/modals/ShiftPlanModalForm.vue